import http from 'axios'

export default {
  getValeursTypeExploitation: () => {
    return http.get(`/web/v1/filtres-comparaison/type-exploitation`)
  },
  getValeursTypeProduction: () => {
    return http.get(`/web/v1/filtres-comparaison/type-production`)
  },
  getValeursPotentielSol: () => {
    return http.get(`/web/v1/filtres-comparaison/potentiel-sol`)
  },
  getValeursRessourceEffluents: () => {
    return http.get(`/web/v1/filtres-comparaison/ressource-effluents`)
  },
  getValeursStockeur: () => {
    return http.get(`/web/v1/filtres-comparaison/stockeur`)
  },
  getValeursRegionsAgrial: () => {
    return http.get(`/web/v1/filtres-comparaison/regions-agrial`)
  },
}
